'use strict';
/**
* Get the main scope in order to feed passwordValidator
*
* @returns {obj} The scope object
*/
function getMainScope() {
    if (typeof window === 'undefined') {
        return exports;
    }
    window.passwordValidator = Object.create(null);

    return window.passwordValidator;
}

(function(exports) {
    'use strict';

    /**
     * @param {string} password string to validate
     * @returns {boolean}       result
     */
    function isMinLengthValid(password) {
        var size = exports.conf.min || 0;

        if (!size) {
            return true;
        }

        return password.length >= size;
    }
    /**
     * @param {string} password string to validate
     * @returns {boolean}       result
     */
    function isMaxLengthValid(password) {
        var size = exports.conf.max || 0;

        if (!size) {
            return true;
        }

        return password.length <= size;
    }
    /**
     * @param {string} password string to validate
     * @returns {boolean}       result
     */
    function isMinMaxLengthValid(password) {
        var size = exports.conf.minmax || null;

        if (!size || size.length !== 2) {
            return true;
        }

        return password.length >= size[0] && password.length <= size[1];
    }
    /**
     * @param {string} password string to validate
     * @returns {boolean}       result
     */
    function isUpperCaseValid(password) {
        var occ = exports.conf.uppercase || 0;

        if (!occ) {
            return true;
        }

        return exports.getUpperCaseCount(password) >= occ;
    }
    /**
     * @param {string}      password string to validate
     * @returns {boolean}   result
     */
    function isLowerCaseValid(password) {
        var occ = exports.conf.lowercase || 0;

        if (!occ) {
            return true;
        }

        return exports.getLowerCaseCount(password) >= occ;
    }

    /**
     * Checks if the character code is in the range of characters
     * @param {number} charCode     decimal character code
     * @param {Object[]} range      range to check, see conf.allow.range
     * @returns {boolean}           true if found otherwise false
     */
    exports.isInRange = function(charCode, range) {
        for (var i = 0; i < range.length; i++) {
            if (charCode >= exports.getDecimal(range[i].start)
                && charCode <= exports.getDecimal(range[i].end)) {
                return true;
            }
        }

        return false;
    };
    /**
     * Check if the character code is in the array of characters.
     * The characters of the list parameter will be converted into decimal values.
     * @param {number} charCode     decimal code of the character
     * @param {Array} list          array of characters
     * @returns {boolean}           true if found otherwise false
     */
    exports.isInArray = function(charCode, list) {
        var charCodes = list.map(exports.getDecimal);

        return charCodes.indexOf(charCode) !== -1;
    };


    /**
     * Checks if the character is allowed.
     * Be careful, if conf.chars.allowed.range and conf.chars.allowed.list
     * are declared and empty the method returns false
     * which means that everything is forbidden
     * @param {string} char     character to validate
     * @returns {boolean}       TRUE if valid otherwise FALSE
     */
    function isCharValid(char) {
        var allowed = exports.conf.chars && exports.conf.chars.allowed || null;

        if (!allowed) {
            return true;
        }
        var code = exports.getDecimal(char);

        if (allowed.range && allowed.range.length > 0 && exports.isInRange(code, allowed.range)) {
            return true;
        }
        if (allowed.list && allowed.list.length > 0) {
            return exports.isInArray(code, allowed.list);
        }

        return false;
    }
    /**
     * @param {string} char character to validate
     * @returns {boolean}   TRUE if forbidden otherwise FALSE
     */
    function isCharForbidden(char) {
        var forbidden = exports.conf.chars && exports.conf.chars.forbidden || null;

        if (!forbidden) {
            return false;
        }
        // get decimal value of the char (letter/number/sign)
        var code = exports.getDecimal(char);

        if (forbidden.range && forbidden.range.length > 0 && exports.isInRange(code, forbidden.range)) {
            return true;
        }
        if (forbidden.list && forbidden.list.length > 0) {
            return exports.isInArray(code, forbidden.list);
        }

        return false;
    }
    /**
     * @param {string} password     string to validate
     * @returns {boolean}           result
     */
    function isAllowed(password) {
        for (var i = 0; i < password.length; i++) {
            if (!isCharValid(password[i])) {
                return false;
            }

            if (isCharForbidden(password[i])) {
                return false;
            }
        }

        return true;
    }
    /**
     * Checks the string contains at least some number of digits
     * @param {string} password     string to validate
     * @returns {boolean}           result
     */
    function isDigitsValid(password) {
        var occ = exports.conf.digits;

        if (!occ) {
            return true;
        }

        return exports.getDigitsCount(password) >= occ;
    }
    /**
     * @param {string} char     character to validate
     * @returns {boolean}       result
     */
    exports.isUpperCase = function(char) {
        if (exports.isLetter(char)) {
            return char.toUpperCase() === char;
        }

        return false;
    };
    /**
     * @param {string} char     character to validate
     * @returns {boolean}       result
     */
    exports.isLowerCase = function(char) {
        if (exports.isLetter(char)) {
            return char.toLowerCase() === char;
        }

        return false;
    };
    /**
     * @param {string} char     character to validate
     * @returns {boolean}       result
     */
    exports.isNumber = function(char) {
        return isFinite(char) && char !== ' ';
    };
    /**
     * Get decimal representation of the character.
     * Important: pass number as string for the conversion
     * Eg: '0' == 48 in decimal and not 0
     * @param {string|number} char      character
     * @returns {number}                decimal values of a character
     */
    exports.getDecimal = function(char) {
        return typeof char === 'string' ? char.charCodeAt(0) : char;
    };
    /**
     *
     * @param {string} password string to validate
     * @returns {number}   result
     */
    exports.getLowerCaseCount = function(password) {
        var found = 0;

        for (var i = 0; i < password.length; i++) {
            // skip non letter chars
            if (exports.isLetter(password[i]) && exports.isLowerCase(password[i])) {
                found++;
            }
        }

        return found;
    };
    /**
     *
     * @param {string} password string to validate
     * @returns {number}   result
     */
    exports.getUpperCaseCount = function(password) {
        var found = 0;

        for (var i = 0; i < password.length; i++) {
            // skip the numbers
            if (exports.isLetter(password[i]) && exports.isUpperCase(password[i])) {
                found++;
            }
        }

        return found;
    };

    /**
     * @param {string} char     character to validate
     * @returns {boolean}       result
     */
    exports.isLetter = function(char) {
        return typeof char === 'string' && char.toUpperCase() !== char.toLowerCase();
    };
    /**
     * Check if the characters is a sign, e.g not letter and not number
     * @param {string} char character
     * @returns {boolean}   result
     */
    exports.isSign = function(char) {
        return exports.isLetter(char) === false && exports.isNumber(char) === false;
    };
    /**
     * Get number of digits present in the password
     * @param {string} password     string to validate
     * @returns {number}  result
     */
    exports.getDigitsCount = function(password) {
        var found = 0;

        for (var i = 0; i < password.length; i++) {
            if (exports.isNumber(password[i])) {
                found++;
            }
        }

        return found;
    };

    /**
     * Pairs of conf keyword and validator
     * @type {Object}
     */
    exports.defaultValidators = {
        'min'       : isMinLengthValid,
        'chars'     : isAllowed,
        'max'       : isMaxLengthValid,
        'uppercase' : isUpperCaseValid,
        'lowercase' : isLowerCaseValid,
        'digits'    : isDigitsValid,
        'minmax'    : isMinMaxLengthValid
    };

    /**
     * Main validation method.
     * The result of the validation is returned in an object which
     * contains a global validation status in the 'result' keyword
     * as well the status for each validator.
     * @param {string} password     string to validate
     * @returns {Object}            result of the validation as an object
     */
    exports.validate = function(password) {
        var status = Object.create(null);

        status.result = true;
        for (var prop in exports.conf) {
            if (exports.conf.hasOwnProperty(prop)) {
                var validator = null;

                if (typeof exports.conf[prop] === 'function') {
                    validator = exports.conf[prop];
                } else if (exports.defaultValidators[prop] !== 'undefined') {
                    validator = exports.defaultValidators[prop];
                }
                if (validator) {
                    // push validation result into the status object
                    status[prop] = validator(password);
                    // this allows an int to be considered as false (useful for positionning the error)
                    if (status[prop] !== true) {
                        status.result = false;
                    }
                }
            }
        }

        return status;
    };
    /**
     * Initializes validator options.
     * No merge is done on options which means that you can't extend default options.
     * Instead, you MUST redeclare the configuration.
     * @see exports.conf for configuration.
     * @param {Object} conf  configuration
     */
    exports.init = function(conf) {
        if (typeof conf !== 'object') {
            conf = {};
        }
        exports.conf = conf;
    };


    /**
     * Extra validators can be injected into conf.
     * Simply add a validator name with anonymous validation function.
     * The password will be pushed into that function.
     * Ex: { min : 4, 'myValidator' : function(password){
     *      return true;
     * }
     * }
     * @type {Object} validator configuration
     */
    exports.conf = {
        chars : {
            // authorized characters
            allowed : {
                // array of characters ranges
                // empty array -> deactivated
                // values: hexadecimal|decimal(see encoding table)|string
                // Important: numbers must be passed as strings for proper conversion
                // ex.: Following declaration are equivalent for the range of numbers 0-9:
                // hexa : [{start : 0x30, end : 0x39}]
                // letteral: [{start : '0', end : '9'}]
                // decimal: [{start : 48, end : 57}]
                range : [{start : 0x21, end : 0x7E}],
                // list of additional characters to complete the ranges array
                list  : []
            },
            // forbidden characters
            forbidden : {
                range : [],
                // list of additional characters to complete the ranges array
                list  : []
            }
        },
        //  minmax[0] -> min, minmax[1] -> max
        minmax    : [8, 36],
        // min characters
        // 0 -> deactivated
        // min       : 8,
        // // max characters
        // // 0 -> deactivated
        // max       : 36,
        // minimum number of upper case chars
        // 0 -> deactivated
        uppercase : 1,
        // minimum number of lower case chars
        // 0 -> deactivated
        lowercase : 1,
        // minimum number of digits
        // 0 -> deactivated
        digits    : 1
    };

// get main scope (different if nodeJS or usual JS)
})(getMainScope());
